import { render, staticRenderFns } from "./configuracao-central-atendimento.vue?vue&type=template&id=fbb419b2&scoped=true"
import script from "./configuracao-central-atendimento.vue?vue&type=script&lang=js"
export * from "./configuracao-central-atendimento.vue?vue&type=script&lang=js"
import style0 from "./configuracao-central-atendimento.vue?vue&type=style&index=0&id=fbb419b2&prod&lang=css"
import style1 from "./configuracao-central-atendimento.vue?vue&type=style&index=1&id=fbb419b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb419b2",
  null
  
)

export default component.exports